import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calculator",
  "use": "icon-calculator-usage",
  "viewBox": "0 0 17 15",
  "content": "<symbol viewBox=\"0 0 17 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-calculator\">\n  <path d=\"M1.22842 9.77791L0.0203766 9.79538L0 8.25257L2.25308 8.22346L2.83236 9.61199L5.24264 0H17V1.54281H6.44777L3.19623 14.4966L1.22842 9.77791ZM7.15223 13.3497L9.80993 8.85223L7.23082 3.92106H14.2521L15.2272 6.23528L13.8038 6.83202L13.2274 5.45805H9.78082L11.5769 8.89007L9.85942 11.801H13.2449L13.8154 10.5581L15.2185 11.2014L14.2346 13.3497H7.15223Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol